import LandingPage, { type LandingPageData } from "./landing";
import { landingContent } from "@shared/landing-content";

const data: LandingPageData = {
  path: "/ai-marketing-bureau",
  seo: {
    nl: {
      title: "AI Marketing Bureau voor D2C E-commerce | Wrkt Digital",
      description: "AI marketing bureau voor D2C e-commerce. Eigen AI-tooling wrkt signal analyseert je markt en optimaliseert campagnes 24/7.",
      keywords: "AI marketing bureau, AI marketing bureau Nederland, AI adverteren e-commerce, AI marketing tooling webshop, AI-gedreven performance marketing Nederland, wrkt signal, AI tooling D2C, concurrentie-analyse advertenties, creative performance AI, anomaly detectie campagnes, AI-first marketing bureau",
    },
    en: {
      title: "AI Marketing Agency for D2C E-commerce | Wrkt Digital",
      description: "AI marketing agency for D2C e-commerce. Proprietary AI tooling wrkt signal analyzes your market and optimizes campaigns 24/7.",
      keywords: "AI marketing agency, AI advertising e-commerce, AI marketing tooling, AI-driven performance marketing, wrkt signal, AI tooling D2C, competitor analysis ads, creative performance AI, anomaly detection campaigns, AI-first marketing agency",
    },
  },
  content: landingContent["/ai-marketing-bureau"],
};

export default function LandingAiMarketing() {
  return <LandingPage data={data} />;
}
